var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_15820)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_531_15820",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 0H0V62H62V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_531_15820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1089 23.7344H14.2334C13.9122 23.7344 13.6041 23.6068 13.377 23.3797C13.1499 23.1526 13.0225 22.8446 13.0225 22.5234C13.0225 22.2023 13.1499 21.8943 13.377 21.6672C13.6041 21.4401 13.9122 21.3125 14.2334 21.3125H34.1089C34.43 21.3125 34.7379 21.4401 34.965 21.6672C35.1921 21.8943 35.3198 22.2023 35.3198 22.5234C35.3198 22.8446 35.1921 23.1526 34.965 23.3797C34.7379 23.6068 34.43 23.7344 34.1089 23.7344Z",
    fill: "#17416F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7662 32.2109H14.2334C13.9122 32.2109 13.6041 32.0834 13.377 31.8563C13.1499 31.6292 13.0225 31.3212 13.0225 31C13.0225 30.6788 13.1499 30.3708 13.377 30.1437C13.6041 29.9166 13.9122 29.7891 14.2334 29.7891H47.7662C48.0874 29.7891 48.3953 29.9166 48.6224 30.1437C48.8495 30.3708 48.9771 30.6788 48.9771 31C48.9771 31.3212 48.8495 31.6292 48.6224 31.8563C48.3953 32.0834 48.0874 32.2109 47.7662 32.2109Z",
    fill: "#17416F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7662 40.6875H14.2334C13.9122 40.6875 13.6041 40.5599 13.377 40.3328C13.1499 40.1057 13.0225 39.7977 13.0225 39.4766C13.0225 39.1554 13.1499 38.8474 13.377 38.6203C13.6041 38.3932 13.9122 38.2656 14.2334 38.2656H47.7662C48.0874 38.2656 48.3953 38.3932 48.6224 38.6203C48.8495 38.8474 48.9771 39.1554 48.9771 39.4766C48.9771 39.7977 48.8495 40.1057 48.6224 40.3328C48.3953 40.5599 48.0874 40.6875 47.7662 40.6875Z",
    fill: "#17416F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_15820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.25ac513a6214cf92a6660f587f5da01d.svg";
export { ForwardRef as ReactComponent };